module.exports = __webpack_public_path__ + "static/media/rightTurn.aae949d9.webp";